import { render, staticRenderFns } from "./SendConsentDialog.vue?vue&type=template&id=11332140&scoped=true&"
import script from "./SendConsentDialog.vue?vue&type=script&lang=js&"
export * from "./SendConsentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11332140",
  null
  
)

export default component.exports